import type { Event } from '@wix/ambassador-events-v3-event/types';

export function getScheduleTbdMessage(event: Event) {
  if (event.dateAndTimeSettings?.dateAndTimeTbd) {
    return event.dateAndTimeSettings?.dateAndTimeTbd || 'TBD';
  }
}
